// React imports.
import React from "react";

import { Assessment2StepsEnum } from "../state";
import { Assessment2FuelStatusEnum } from "../state";


const Assessment2TopParagraph = ({fuelType }) => (
    <div>
        {(fuelType.numTotalVendors === 0)
          &&<span>
                You have indicated that your state/territory does not serve
                households with  {fuelType.descriptionHeat}.  Therefore it would not be applicable for you to conduct
                a check of  {fuelType.description}  expenditure data.
            </span>
          }

        {(fuelType.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.OverMinNoIssues
          && fuelType.numTotalVendors !== 0)
          &&<span>
                Your data collection efforts for {fuelType.descriptionHeat} households  <strong>have not</strong>  been flagged
                because you both requested and received data from at
                least  {fuelType.requiredVendors}  {fuelType.description}  vendors. This means that you
                likely <strong>do not</strong> have a data reliability
                issue with regards to data collection for {fuelType.descriptionHeating}  expenditure data.
            </span>
          }
          {(fuelType.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.OverMinNotEnoughRequested
            && fuelType.numTotalVendors !== 0)
          &&<span>
                Your data collection efforts for {fuelType.descriptionHeat} households  <strong>have</strong>  been flagged
                because you did not <strong>request</strong> data from at
                least  {fuelType.requiredVendors}  {fuelType.description}  vendors in your state/territory.
                This means that you  <strong>may</strong>  have a data reliability issue
                for {fuelType.descriptionHeat}  expenditure data because collecting data from fewer vendors
                increases the probability that the
                sample you have collected is not adequately representative of the entire state/territory.
            </span>
          }
          {(fuelType.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.OverMinNotEnoughReceived
            && fuelType.numTotalVendors !== 0)
            &&<span>
                  Your data collection efforts for {fuelType.descriptionHeat} households  <strong>have</strong>  been flagged
                  because you requested but did NOT  <strong>receive</strong>  data from at
                  least  {fuelType.requiredVendors}   {fuelType.description}  vendors in your state/territory.
                  This means that you  <strong>may</strong>  have a data reliability issue
                  for  {fuelType.descriptionHeating}  expenditure data because
                  collecting data from fewer vendors increases the probability that the sample you have
                  collected is not adequately representative of the entire state/territory.
              </span>
            }
          {(fuelType.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.UnderMinNoIssues
              && fuelType.numTotalVendors !== 0)
              &&<span>
                    Your data collection efforts for  {fuelType.descriptionHeat}  households have not been flagged
                    because your state has fewer than  {fuelType.requiredVendors}  {fuelType.description}  vendors BUT you requested and
                    received data from all of them. This means that you likely  <strong>do not</strong>  have a data
                    reliability issue with regards to data collection for  {fuelType.descriptionHeating}  expenditure data.
                </span>
          }
          {(fuelType.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.UnderMinNotEnoughRequested
            && fuelType.numTotalVendors !== 0)
              &&<span>
                    Your data collection efforts for  {fuelType.descriptionHeat}  households <strong>have</strong>  been
                    flagged because your state/territory has fewer
                    than  {fuelType.requiredVendors}  {fuelType.description}  vendors, BUT you did
                    NOT  <strong>request</strong>  data from all of them. This means that
                    you  <strong>may</strong>  have a data reliability
                    issue for  {fuelType.descriptionHeating}  expenditure data because collecting data from fewer
                    vendors increases the probability that the sample you have collected is not
                    adequately representative of the entire state/territory.            
                </span>
          }
          {(fuelType.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.UnderMinNotEnoughReceived
            && fuelType.numTotalVendors !== 0)
              &&<span>
                  Your data collection efforts for {fuelType.descriptionHeat}  households <strong>have</strong>  been flagged
                  because your state/territory has fewer than  {fuelType.requiredVendors}  {fuelType.description}  vendors and you
                  requested, but did not  <strong>receive</strong>,  data from all of them. This means that
                  you  <strong>may</strong>  have a data reliability issue
                  for {fuelType.descriptionHeating}  expenditure data because collecting data from fewer vendors increases the
                  probability that the sample you have collected is not adequately
                  representative of the entire state/territory.   
              </span>
          }

    </div>
);

export default Assessment2TopParagraph;
